module.exports = __webpack_public_path__ + "img/Fill_spectral.8e151534.png";